import { put } from "@redux-saga/core/effects";
import { uniqueId } from "lodash";

import { IAddCollaboratorAction } from "./../types";
import { addCollaboratorWithTempId } from "./../actionCreators";
import { CollaborationStatus } from "./../../collaborators/types";

export function* addCollaboratorsSaga({ payload: { email, role } }: IAddCollaboratorAction) {
    try {
        const tempId = uniqueId("tempId_");

        yield put(
            addCollaboratorWithTempId({
                id: tempId,
                email,
                role,
                status: CollaborationStatus.Pending,
            }),
        );
    } catch (error) {
        // yield put(Handle Error);
    }
}
